React = require 'react'
FormFields = require './internal/form-fields'
t = require('views/internal/recup-with-helpers')('credit_card')
formatMoney = require 'lib/format/money'
localizeCount = require 'lib/localize-count'

module.exports = class extends React.Component
  displayName: 'SummaryComponent'

  formFields: []
  requiredFields: []

  render: t.renderable ->
    { monthlyProduct, yearlyProduct, billingStrategy, selectedBillingPlan, subTotalCost, tax, region } = @props

    isYearly = selectedBillingPlan.toString() == yearlyProduct.productNumber.toString()
    totalPlusTax = (parseFloat(subTotalCost) + parseFloat(tax || 0)).toFixed(2)
    licenseQuantityCopy = if isYearly then 'yearly-licenses' else 'monthly-licenses'

    render = =>
      t.div '.billing-summary', ->
        t.h3 ->
          t.format 'billing-plan-summary'
        t.table ->
          t.tbody ->
            t.tr ->
              t.td ->
                t.span '.licences-quantity', ->
                  if billingStrategy.flatRate
                    t.format 'one-trello-gold-license'
                  else
                    t.text localizeCount licenseQuantityCopy, billingStrategy.userCount
                if isYearly
                  t.span '.save-info.small', ->
                    t.format 'monthly-saving-info',
                    savePercent: yearlyProduct.savePercent
                else
                  t.span '.switch-to-annual.small', ->
                    t.format 'annual-saving-info',
                      savePercent: yearlyProduct.savePercent
              t.td ->
                t.strong '.cost-each-monthly.price', ->
                  t.text '$' + formatMoney (if isYearly then yearlyProduct.price else monthlyProduct.monthlyPrice)
                if !billingStrategy.flatRate
                  t.span '.small', ->
                    t.format 'each'
            t.tr ->
              t.td ->
                if region != null
                  t.format 'sales-tax',
                    region: (if tax then region else '')
                else
                  t.span '.u-form-error', ->
                    t.format 'could-not-calculate-sales-tax'
              t.td ->
                if tax != null
                  t.strong ->
                    t.text '$' + formatMoney tax

          t.tfoot ->
            t.tr ->
              t.td ->
                t.format 'total-label'
              t.td ->
                t.strong '.price', ->
                  t.text '$' + formatMoney totalPlusTax, true

    t.tag FormFields, {
      @formFields
      @requiredFields
      initialState: {}
      ref: (formFieldsRef) => @formFieldsRef = formFieldsRef
      render
    }



// WEBPACK FOOTER //
// ./app/scripts/views/billing/form-sections/summary-component.coffee